import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { UnitLevelLayoutComponent } from "./_layouts/unit-level-layout/unit-level-layout.component";
import { UNIT_LEVEL_LAYOUT_ROUTES } from "./_routes/unit-level-layout-routes";
import { ChainLevelLayoutComponent } from "./_layouts/chain-level-layout/chain-level-layout.component";
import { CHAIN_LEVEL_LAYOUT_ROUTES } from "./_routes/chain-level-layout-routes";
import { ChainLevelGuard } from "./_guards/chain-level-route.guard";

const routes: Routes = [
  // Full Page Layouts
  {
    path: "",
    redirectTo: "sign-in",
    pathMatch: "full",
  },
  // Property Level Routes
  {
    path: "unit",
    component: UnitLevelLayoutComponent,
    children: UNIT_LEVEL_LAYOUT_ROUTES,
  },

  // chain level routes
  {
    path: "chain",
    canActivateChild: [ChainLevelGuard],
    component: ChainLevelLayoutComponent,
    children: CHAIN_LEVEL_LAYOUT_ROUTES,
  },
  {
    path: "sign-in",
    loadChildren: () =>
      import("./_pages/login/login.module").then((m) => m.LoginModule),
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      initialNavigation: "enabledBlocking",
      scrollPositionRestoration: "enabled",
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
